var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/exhaustive_analysis.results.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var TheView = GenericView.extend({
    el: '#exhaustiveResults',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	initialize: function (options) {
        this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template(this.data));
    },
    events: {

    },
});

module.exports= TheView;